import React from 'react';
import PropTypes from 'prop-types';

import Divider from 'components/FormGroup/Divider';

import { formatDate } from 'utils/moment';

import ExportCSV from '../../Tools/export-csv';
import ExportPDF from '../../Tools/export-pdf';

import * as S from './styles';

const ExportUser = ({ isVisible, setIsVisible, employee }) => (
  <S.Container isVisible={isVisible}>
    <S.Modal>
      <S.CloseModal onClick={() => setIsVisible(false)}>X</S.CloseModal>
      <Divider
        text="Exporte informações do funcionário"
        hasTopSpacing={false}
      />
      <S.ModalActions>
        <S.ModalCard
          onClick={() => {
            try {
              ExportCSV(setIsVisible)(employee);
            } catch (error) {
              console.warn(error);
            }
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
          >
            <path
              d="M99.9729 45.7042C99.9604 45.5146 99.925 45.3333 99.8625 45.1542C99.8396 45.0875 99.8229 45.0229 99.7937 44.9583C99.6937 44.7417 99.5667 44.5375 99.3917 44.3646L87.5 32.4708V20.8333C87.5 20.7875 87.4771 20.7479 87.4729 20.7021C87.4604 20.5187 87.425 20.3417 87.3667 20.1667C87.3437 20.1 87.3271 20.0354 87.2958 19.9708C87.1937 19.75 87.0667 19.5396 86.8875 19.3604L68.1375 0.610417C67.9583 0.43125 67.7479 0.302083 67.525 0.202083C67.4625 0.172917 67.4 0.15625 67.3354 0.135417C67.1583 0.0729167 66.9771 0.0375 66.7875 0.0270833C66.7479 0.0208333 66.7104 0 66.6667 0H14.5833C13.4333 0 12.5 0.933333 12.5 2.08333V32.4708L0.60625 44.3646C0.43125 44.5396 0.30625 44.7437 0.20625 44.9583C0.177083 45.0229 0.160417 45.0875 0.1375 45.1542C0.075 45.3333 0.0375 45.5146 0.0270833 45.7042C0.0229167 45.75 0 45.7875 0 45.8333V85.4167C0 86.5667 0.933333 87.5 2.08333 87.5H12.5V97.9167C12.5 99.0667 13.4333 100 14.5833 100H85.4167C86.5667 100 87.5 99.0667 87.5 97.9167V87.5H97.9167C99.0667 87.5 100 86.5667 100 85.4167V45.8333C100 45.7875 99.9771 45.75 99.9729 45.7042ZM92.8875 43.75H87.5V38.3625L92.8875 43.75ZM80.3875 18.75H68.75V7.1125L80.3875 18.75ZM16.6667 4.16667H64.5833V20.8333C64.5833 21.9833 65.5167 22.9167 66.6667 22.9167H83.3333V43.75H16.6667V4.16667ZM12.5 38.3625V43.75H7.1125L12.5 38.3625ZM83.3333 95.8333H16.6667V87.5H83.3333V95.8333ZM95.8333 83.3333H4.16667V47.9167H95.8333V83.3333Z"
              fill="#DBDBDB"
            />
            <path
              d="M48.7958 58.0937C49.1021 57.8104 49.4458 57.6042 49.8229 57.4729C50.2 57.3437 50.5896 57.2792 50.9917 57.2792C52.3854 57.2792 53.5417 57.8333 54.4625 58.9437L56.8 55.8979C56.1146 55.0958 55.2708 54.4875 54.2687 54.0729C53.2646 53.6604 52.1271 53.4542 50.8521 53.4542C49.9792 53.4542 49.1167 53.6021 48.2667 53.8958C47.4167 54.1917 46.6542 54.6458 45.9812 55.2604C45.3083 55.875 44.7646 56.6479 44.3521 57.5792C43.9396 58.5125 43.7312 59.6292 43.7312 60.9271C43.7312 61.9667 43.8667 62.8562 44.1375 63.6C44.4083 64.3458 44.775 64.9937 45.2354 65.5479C45.6958 66.1042 46.2271 66.5812 46.8292 66.9833C47.4312 67.3854 48.075 67.75 48.7604 68.0812C49.8458 68.625 50.7437 69.2146 51.4521 69.8521C52.1604 70.4896 52.5146 71.3521 52.5146 72.4375C52.5146 73.5479 52.2187 74.4083 51.6292 75.0229C51.0396 75.6375 50.2958 75.9437 49.3979 75.9437C48.5958 75.9437 47.8104 75.7542 47.0417 75.3771C46.2729 75 45.6187 74.4792 45.075 73.8187L42.7729 76.9354C43.4812 77.7625 44.425 78.4458 45.6062 78.9896C46.7875 79.5333 48.0729 79.8042 49.4667 79.8042C50.4354 79.8042 51.3562 79.6396 52.2292 79.3083C53.1021 78.9771 53.8646 78.4875 54.5146 77.8375C55.1646 77.1896 55.6833 76.3917 56.0729 75.4479C56.4625 74.5042 56.6583 73.4167 56.6583 72.1896C56.6583 71.1271 56.4937 70.2062 56.1625 69.4271C55.8312 68.6479 55.4062 67.975 54.8875 67.4083C54.3687 66.8417 53.7896 66.3583 53.1521 65.9562C52.5146 65.5542 51.8896 65.2 51.275 64.8937C50.2354 64.375 49.3979 63.825 48.7604 63.2458C48.1229 62.6687 47.8042 61.8479 47.8042 60.7854C47.8042 60.1708 47.8917 59.6396 48.0708 59.1917C48.2479 58.7437 48.4896 58.3771 48.7958 58.0937Z"
              fill="#DBDBDB"
            />
            <path
              d="M31.6187 60.1125C32.0437 59.2854 32.575 58.6312 33.2125 58.1458C33.85 57.6625 34.5937 57.4208 35.4437 57.4208C36.9792 57.4208 38.2292 58.1167 39.1979 59.5104L41.6417 56.5354C40.9563 55.5437 40.0708 54.7833 38.9854 54.25C37.9 53.7187 36.6354 53.4542 35.1958 53.4542C33.8021 53.4542 32.5333 53.7792 31.3875 54.4271C30.2417 55.0771 29.2687 55.9854 28.4646 57.1542C27.6625 58.325 27.0417 59.7167 26.6062 61.3333C26.1687 62.9521 25.9521 64.7167 25.9521 66.6292C25.9521 68.5417 26.1708 70.3 26.6062 71.9062C27.0417 73.5125 27.6562 74.8979 28.4479 76.0667C29.2396 77.2375 30.2062 78.1521 31.3521 78.8125C32.4979 79.4729 33.7792 79.8042 35.1958 79.8042C36.7542 79.8042 38.0458 79.4979 39.0729 78.8833C40.1 78.2687 40.9437 77.4667 41.6042 76.475L39.1604 73.6062C38.7583 74.2208 38.2563 74.7396 37.6563 75.1646C37.0563 75.5896 36.3396 75.8021 35.5146 75.8021C34.6417 75.8021 33.8792 75.5604 33.2292 75.075C32.5792 74.5917 32.0437 73.9375 31.6167 73.1104C31.1896 72.2833 30.8729 71.3104 30.6604 70.1875C30.4479 69.0667 30.3417 67.8812 30.3417 66.6292C30.3417 65.3542 30.4479 64.1562 30.6604 63.0333C30.875 61.9125 31.1937 60.9396 31.6187 60.1125Z"
              fill="#DBDBDB"
            />
            <path
              d="M66.6812 74.2083H66.575L62.3958 54.0917H57.65L63.7771 79.1667H69.1604L75.3937 54.0917H70.8604L66.6812 74.2083Z"
              fill="#DBDBDB"
            />
          </svg>
          <p>Exportar em CSV</p>
        </S.ModalCard>
        <S.ModalCard
          onClick={() => {
            const {
              nome,
              // genero,
              // nome_pai: pai,
              // nome_mae: mae,
              // nacionalidade,
              dt_nascimento,
              // estado_civil,
              // grau_instrucao,
              cep,
              pais,
              uf,
              cidade,
              logradouro,
              numero,
              bairro,
              complemento,
              endereco,
              matricula,
              dt_admissao: data_admissao,
              dt_demissao: data_demissao,
              // nome_centro_de_custo: centro_de_custo,
              cargo,
              nome_funcao: funcao,
              senioridade,
              email,
              documentos,
              // contatos,
            } = employee;

            const [pis] = documentos;

            const obj = {
              nome: nome || '',
              // genero: genero || '',
              nascimento: dt_nascimento ? formatDate(dt_nascimento) : '',
              // estado_civil: estado_civil || '',
              // nacionalidade: nacionalidade || '',
              // rg: rg ? rg.documento : '',
              // cpf: cpf ? cpf.documento : '',
              pis: pis ? pis.documento : '',
              // 'nome do pai': pai || '',
              // 'noma da mãe': mae || '',
              // grau_instrucao: grau_instrucao || '',
              logradouro: logradouro || '',
              endereco: endereco || '',
              numero: numero || '',
              complemento: complemento || '',
              bairro: bairro || '',
              cidade: cidade || '',
              cep: cep || '',
              estado: uf || '',
              pais: pais || '',
              // celular: cel ? cel.contato : '',
              // residencial: res ? res.contato : '',
              // comercial: com ? com.contato : '',
              email: email || '',
              cargo: cargo || '',
              funcao: funcao || '',
              senioridade: senioridade || '',
              matricula: matricula || '',
              // 'centro de custo': centro_de_custo || '',
              'data de admissao': data_admissao
                ? formatDate(data_admissao)
                : '',
              'data de demissao': data_demissao
                ? formatDate(data_demissao)
                : '',
            };
            try {
              ExportPDF(setIsVisible)(obj);
            } catch (error) {
              console.warn(error);
            }
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="107"
            viewBox="0 0 100 107"
            fill="none"
          >
            <path
              d="M99.4296 28.7187L72.3935 0.625542C72.0086 0.225925 71.4775 0 70.9229 0H30.6275C26.1179 0 22.449 3.66744 22.449 8.17515V36.7347H6.11882C2.74488 36.7347 0 39.4788 0 42.8519V73.4748C0 76.8477 2.74488 79.5918 6.11882 79.5918H22.449V97.9615C22.449 102.461 26.1179 106.122 30.6275 106.122H91.8215C96.3311 106.122 100 102.463 100 97.9661V30.134C100 29.6063 99.7954 29.0991 99.4296 28.7187ZM71.4286 5.50945L93.6229 28.5714H71.4286V5.50945ZM6.11882 75.5102C4.99542 75.5102 4.08177 74.5972 4.08177 73.4748V42.8519C4.08177 41.7295 4.99563 40.8163 6.11882 40.8163H61.2282C62.3516 40.8163 63.2653 41.7295 63.2653 42.8519V73.4748C63.2653 74.5972 62.3514 75.5102 61.2282 75.5102H6.11882ZM95.9182 97.9661C95.9182 100.213 94.0804 102.041 91.8213 102.041H30.6275C28.3685 102.041 26.5306 100.211 26.5306 97.9617V79.5918H61.2282C64.6022 79.5918 67.3471 76.8477 67.3471 73.4748V42.8519C67.3471 39.4788 64.6022 36.7347 61.2282 36.7347H26.5306V8.17515C26.5306 5.91777 28.3685 4.08157 30.6275 4.08157H67.3469V30.6122C67.3469 31.7393 68.2607 32.6529 69.3876 32.6529H95.9182V97.9661Z"
              fill="white"
            />
            <path
              d="M24.3982 51.7956C23.7206 50.9147 22.8795 50.3426 21.8751 50.0796C21.2214 49.9042 19.8183 49.8166 17.6658 49.8166H11.9858V67.3469H15.5254V60.7341H17.8333C19.4357 60.7341 20.6595 60.6504 21.5045 60.4829C22.1263 60.3473 22.7382 60.0704 23.3401 59.6517C23.942 59.2333 24.4382 58.6573 24.8289 57.9239C25.2196 57.1906 25.4149 56.2857 25.4149 55.2095C25.4146 53.8144 25.0758 52.6765 24.3982 51.7956ZM21.3669 56.6206C21.0999 57.0113 20.7312 57.2982 20.2607 57.4816C19.7902 57.6651 18.8577 57.7567 17.4625 57.7567H15.5254V52.7822H17.2353C18.5109 52.7822 19.3599 52.822 19.7823 52.9018C20.3562 53.0054 20.8307 53.2645 21.2052 53.679C21.5799 54.0936 21.7673 54.6199 21.7673 55.2574C21.7675 55.7756 21.6338 56.2299 21.3669 56.6206Z"
              fill="white"
            />
            <path
              d="M42.4307 54.6058C42.0481 53.4857 41.4899 52.5391 40.7566 51.7657C40.0233 50.9924 39.1422 50.4543 38.1139 50.1513C37.3486 49.9281 36.2364 49.8166 34.7777 49.8166H28.3083V67.3469H34.969C36.2764 67.3469 37.3207 67.2233 38.1019 66.9761C39.1463 66.6413 39.9754 66.175 40.5891 65.577C41.4022 64.7877 42.028 63.7555 42.4666 62.4799C42.8253 61.4355 43.0046 60.1919 43.0046 58.7491C43.0046 57.1069 42.8133 55.7258 42.4307 54.6058ZM38.9867 61.8045C38.7475 62.5898 38.4387 63.1538 38.06 63.4964C37.6813 63.8392 37.205 64.0824 36.6311 64.2258C36.1927 64.3375 35.4791 64.3933 34.4906 64.3933H31.8479V52.7822H33.4383C34.8811 52.7822 35.8499 52.8379 36.344 52.9497C37.0056 53.0931 37.5518 53.3681 37.9823 53.7748C38.4128 54.1815 38.7475 54.7473 38.9867 55.4728C39.2259 56.1982 39.3455 57.2385 39.3455 58.5938C39.3455 59.949 39.2259 61.0191 38.9867 61.8045Z"
              fill="white"
            />
            <path
              d="M58.0477 52.7822V49.8166H46.0299V67.3469H49.5695V59.8972H56.8878V56.9315H49.5695V52.7822H58.0477Z"
              fill="white"
            />
          </svg>
          <p>Exportar em PDF</p>
        </S.ModalCard>
      </S.ModalActions>
    </S.Modal>
  </S.Container>
);

ExportUser.defaultProps = {
  isVisible: false,
  employee: [],
};

ExportUser.propTypes = {
  isVisible: PropTypes.bool,
  setIsVisible: PropTypes.func.isRequired,
  employee: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
};

export default ExportUser;
